import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/LeadCRM/app/(auth)/forgot-password/_components/ForgotPasswordForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/LeadCRM/components/ui/AppLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/LeadCRM/node_modules/lucide-react/dist/esm/Icon.mjs");
